const observerAnimationElements = (observerEl, element, type = 'inverse', position) => {
    const observerElement = document.querySelector(observerEl);
    const elementHasIntersected = (entries) => {
        if (type === 'normal') {
            if (entries[0].isIntersecting) {
                $(element).addClass('visible')
            } else {
                $(element).removeClass('visible')
            }
        } else {
            if (!entries[0].isIntersecting) {
                $(element).addClass('visible')
            } else {
                $(element).removeClass('visible')
            }
        }

    };
    let pos = !position ? 0.5 : position
    const ioConfiguration = {
        root: null,
        rootMargin: '0px',
        threshold: pos
    };

    const observer = new IntersectionObserver(elementHasIntersected, ioConfiguration);
    observer.observe(observerElement);
}
export default observerAnimationElements;